import { useCallback, useEffect, useState } from 'react'

import { ProcessingText } from 'core-components/library/loader'
import { wsConnectionPool } from 'src/core/classes/ws/WSConnectionPool'

export const HealthCheck = () => {
  const [isSocketsConnected, setIsSocketsConnected] = useState<boolean>(false)

  const connectSockets = useCallback(async () => {
    const wsClientsArray = Array.from(wsConnectionPool.wsClientMap).map((el) => el[1])
    await Promise.all(
      wsClientsArray.map(async (wsClient) => {
        await wsClient.connect()
      })
    )
    return wsClientsArray.every((wsClient) => wsClient.isConnected)
  }, [])

  useEffect(() => {
    connectSockets().then((res) => {
      setIsSocketsConnected(res)
    })
  }, [connectSockets])

  if (!isSocketsConnected) {
    return <ProcessingText text={'Sockets connecting'} />
  }

  return <div>true</div>
}
